module.exports = __webpack_public_path__ + "static/media/13_chemopharm.2906f1e2.svg";